import React from 'react';
import PropTypes from 'prop-types';

import { Button, InputGroup, Input, InputGroupAddon, InputGroupText } from 'reactstrap';

import { Field, ErrorMessage } from "formik";
import { CurrentTheme } from "common";
import MagstimInputGroup from './MagstimInputGroup'

const AUTO_COMPLETE_OFF = 'off';

class MagstimInputGroupTextWithButton extends MagstimInputGroup {

    
    render() {

        const placeholder = this.props.title.replace('*', '')

        return(
            <>
                <InputGroupAddon addonType="prepend" className="d-md-none d-lg-none prepend-mobile">
                    <InputGroupText>{this.props.title}</InputGroupText>
                </InputGroupAddon>
                <InputGroup size={CurrentTheme().ControlSize}>
                    <InputGroupAddon addonType="prepend"  className="d-none d-md-block">
                        <InputGroupText>{this.props.title}</InputGroupText>
                    </InputGroupAddon>
                    <Input type="text" autoComplete={AUTO_COMPLETE_OFF} onFocus={this.onFocus} name={this.props.name} placeholder={placeholder} tag={Field} className={`form-control ${ this.props.touched && this.props.errors ? "is-invalid" : "" }`} />
                    <InputGroupAddon addonType="append">
                        <Button color="primary" size={CurrentTheme().ControlSize} onClick={this.props.onClick}><i className="fas fa-times"></i></Button>
                    </InputGroupAddon>
                    <ErrorMessage component="div" name={this.props.name} className="invalid-feedback"/>       
                </InputGroup>
            </>
        );
    }
}

MagstimInputGroupTextWithButton.propTypes = {
    title: PropTypes.string,
    name:PropTypes.string,
    touched:PropTypes.bool,
    errors:PropTypes.string,
    onClick:PropTypes.func
};

MagstimInputGroupTextWithButton.defaultProps = {
    title: "",
    name:"",
    touched:false,
    errors:undefined,
    onClick:undefined
};

export default MagstimInputGroupTextWithButton